import React from 'react';
import {NearMe} from '@material-ui/icons';
import {FormattedMessage} from 'react-intl';
import {Divider, Toolbar} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import {ToggleButton, ToggleButtonGroup} from '@material-ui/lab';

import LineIcon from '../../../assets/icons/LineIcon';
import PolygonIcon from '../../../assets/icons/PolygonIcon';
import {ToolType} from '../../../base-components/StudioAnnotator/Annotator';

export type TestRegionSelectionProps = {
  status?: string;
  disabled?: boolean;
  activeTool: ToolType;

  onReset?: () => void;
  onChangeActiveTool: (tool: ToolType) => void;
};

export function TestRegionToolbar({
  status,
  activeTool,
  disabled = false,

  onReset = () => {},
  onChangeActiveTool,
}: TestRegionSelectionProps) {
  return (
    <Toolbar
      variant="dense"
      className={`test-region-selection__toolbar ${
        disabled ? 'test-region-selection__toolbar__disabled' : ''
      }`}
    >
      <h5 className="add-streaming-device__preview-title">
        <FormattedMessage id="stream.preview" />
      </h5>

      {status && <FormattedMessage id={`stream.status.${status}`} />}

      <div className="toolbar_spacer" />

      <IconButton
        onClick={onReset}
        size="small"
        aria-label="clear all"
        disabled={disabled}
      >
        <DeleteIcon />
      </IconButton>

      <Divider orientation="vertical" flexItem />

      <ToggleButtonGroup
        exclusive
        size="small"
        value={activeTool}
        aria-label="text alignment"
        onChange={(_, value) => onChangeActiveTool(value)}
      >
        <ToggleButton value="SELECT" aria-label="select" disabled={disabled}>
          <NearMe />
        </ToggleButton>
        <ToggleButton value="LINE" aria-label="draw line" disabled={disabled}>
          <LineIcon />
        </ToggleButton>
        <ToggleButton value="POLY" aria-label="draw polygon" disabled={disabled}>
          <PolygonIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Toolbar>
  );
}
